module.exports = __webpack_public_path__ + "img/mx.fc56379.svg";